import { createReducer } from '@reduxjs/toolkit'
import { Actions_StationsCounters } from './Actions'
import { IStateStationsCounters } from './TReducer'

const initialState: IStateStationsCounters = {
  isLoading: false,
  data: null,
  responseInfo: null,
}

const ReducerStationsCounters = createReducer(initialState, (builder) => {
  builder
    .addCase(Actions_StationsCounters.store.showLoader, (state) => {
      state.isLoading = true
    })
    .addCase(Actions_StationsCounters.store.hideLoader, (state) => {
      state.isLoading = false
    })
    .addCase(Actions_StationsCounters.store.saveStationsCounters, (state, action) => {
      const payload = action.payload
      return { ...state, ...payload }
    })
})

export default ReducerStationsCounters
